// French for the lifecycle console. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Write the qualification note here (at least 20 characters) — why this engagement is worth pursuing': 'Rédigez ici la note de qualification (au moins 20 caractères) — pourquoi cet engagement mérite d’être poursuivi',
  // ── shared pieces (PhaseRail, GateLampBadge, marks) ──
  'Phase rail': 'Barre de phase',
  'clear': 'libre',
  'held — ticked by the operator': 'satisfaite — cochée par l’opérateur',
  'outstanding': 'ouverte',
  'not yet applicable': 'pas encore applicable',
  'read from the record': 'lu dans le dossier',
  'and': 'et',
  'and {n} more': 'et {n} de plus',

  // ── phases (crm.PHASE_LABELS) and commercial models (crm.COMMERCIAL_MODEL_LABELS) ──
  'Qualify': 'Qualification',
  'Discovery': 'Discovery',
  'Design': 'Conception',
  'Contracting': 'Contractualisation',
  'Mobilise': 'Mobilisation',
  'Implement': 'Réalisation',
  'Acceptance': 'Acceptation',
  'Handover': 'Transfert',
  'Close (phase)': 'Clôture',
  'Fixed price': 'Forfait',
  'Time & materials': 'En régie',
  'Capped T&M': 'Régie plafonnée',
  'Retainer': 'Retainer',

  // ── a condition row ──
  'Untick this condition': 'Décocher cette condition',
  'Tick this condition': 'Cocher cette condition',
  'automatic': 'automatique',
  'automatic · the engine reads this, you cannot tick it': 'automatique · le moteur lit cela, vous ne pouvez pas le cocher',
  'The same subjects also sit under {list}{more}. {n} conditions, {refs}{moreRefs}, one piece of work.': 'Les mêmes éléments figurent aussi sous {list}{more}. {n} conditions, {refs}{moreRefs}, un seul travail.',
  'and {n} other condition': 'et {n} autre condition',
  'and {n} other conditions': 'et {n} autres conditions',
  'manual · ticked': 'manuel · coché',
  'manual · not yet ticked': 'manuel · pas encore coché',
  'why is this true? — recorded on the gate, quoted back in the record': 'pourquoi est-ce vrai ? — consigné sur le gate, cité dans le protocole',
  'saved': 'enregistré',
  'manual · you are the source': 'manuel · vous êtes la source',
  'Remove this custom condition': 'Retirer cette condition personnalisée',

  // ── a gate panel ──
  '{open} outstanding · {held} held': '{open} ouvertes · {held} satisfaites',
  '{n} n/a': '{n} n/a',
  '{n} skipped': '{n} ignorées',
  'Reading {gate}…': 'Lecture de {gate}…',
  '{subject} — “{error}”. Nothing was written.': '{subject} — «{error}». Rien n’a été écrit.',
  '{gate} could not be evaluated': '{gate} n’a pas pu être évalué',
  'Crossing {from} → {to} means clearing {n} gate, in order.': 'La transition {from} → {to} suppose de franchir {n} gate, dans l’ordre.',
  'Crossing {from} → {to} means clearing {n} gates, in order.': 'La transition {from} → {to} suppose de franchir {n} gates, dans l’ordre.',

  // ── toasts ──
  '{from} → {to} (forced)': '{from} → {to} (forcé)',
  '{from} → {to}': '{from} → {to}',
  'Condition added': 'Condition ajoutée',
  'Condition removed': 'Condition retirée',
  'Name cannot be empty': 'Le nom ne peut pas être vide',
  'Review window must be a whole number of days between 0 and 365': 'Le délai de vérification doit être un nombre entier de jours entre 0 et 365',
  'Engagement updated': 'Mandat mis à jour',
  'Engagement archived': 'Mandat archivé',
  'Engagement restored': 'Mandat rétabli',

  // ── no engagement / loading / failed ──
  'Lifecycle': 'Cycle de vie',
  'no engagement selected': 'aucun mandat sélectionné',
  'Lifecycle is a per-engagement surface': 'Le cycle de vie est une vue propre à chaque mandat',
  'A phase, a gate and every checklist tick hang off one engagement — {a}, {b}. There is nothing to show until one is chosen.': 'Une phase, un gate et chaque coche de la checklist dépendent d’un mandat — {a}, {b}. Il n’y a rien à montrer tant qu’aucun n’est choisi.',
  '{n} of {total} outstanding': '{n} sur {total} ouvertes',
  'No engagement exists yet.': 'Aucun mandat n’existe encore.',
  'The gate state in each label comes from {endpoint}.': 'L’état du gate dans chaque étiquette provient de {endpoint}.',
  'Reading the gate…': 'Lecture du gate…',
  'the console could not be read': 'la console n’a pas pu être lue',
  'The lifecycle console could not be loaded': 'La console du cycle de vie n’a pas pu être chargée',
  'The endpoint {endpoint} answered: “{error}”': 'Le point de terminaison {endpoint} a répondu : «{error}»',
  'no answer': 'aucune réponse',

  // ── masthead ──
  'sponsor {name}': 'sponsor {name}',
  'not named': 'sans nom',
  'child of {code}': 'rattaché à {code}',
  'The correspondence language — everything produced inside this engagement is written in it.': 'La langue de correspondance — tout ce qui est produit dans ce mandat y est rédigé.',
  'estimate {value}': 'estimation {value}',
  'none': 'aucun',
  'kickoff {date}': 'kickoff {date}',
  'not set': 'non défini',
  'review window {n} d': 'délai de vérification {n} j',
  'archived': 'archivé',
  'Engagement record →': 'Dossier du mandat →',
  'Scope document →': 'Document de périmètre →',
  'name · sponsor · estimate · archive': 'Nom · Sponsor · Estimation · Archive',

  // ── verdict ──
  'Verdict': 'Verdict',
  'not evaluated': 'non évalué',
  'The gate engine did not answer, so {verdict}.': 'Le moteur du gate n’a pas répondu, donc {verdict}.',
  'no verdict can be given': 'aucun verdict ne peut être rendu',
  'The phase is a column and is still true: {code} is in {phase}, step {step} of {count}. The conditions are queries and they failed — showing them as unmet would be a guess, and showing them as met would be a lie.': 'La phase est une colonne et reste vraie : {code} est en {phase}, étape {step} sur {count}. Les conditions sont des requêtes, et elles ont échoué — les montrer comme non satisfaites serait une supposition, et les montrer comme satisfaites serait un mensonge.',
  '{code} can leave {phase}. All {n} conditions on {gate} are held.': '{code} peut quitter {phase}. Les {n} conditions sur {gate} sont toutes satisfaites.',
  '{code} cannot leave {phase}: {open} of {total} conditions on {gate} are outstanding.': '{code} ne peut pas quitter {phase} : {open} des {total} conditions sur {gate} sont ouvertes.',
  '{n} you can tick here': '{n} que vous pouvez cocher ici',
  '{n} the engine reads elsewhere': '{n} que le moteur lit ailleurs',
  '. The {n} automatic subjects — {raw}{rawMore} — all come down to {roots}{rootsMore}.': '. Les {n} sujets automatiques — {raw}{rawMore} — se ramènent tous à {roots}{rootsMore}.',
  '. The automatic ones come down to {raw}{rawMore}.': '. Les automatiques se ramènent à {raw}{rawMore}.',
  'Move to {phase}': 'Passer à {phase}',
  'Gate {gate} is not clear': 'Le gate {gate} n’est pas libre',
  'Advance to {phase}': 'Avancer vers {phase}',
  'Force past {gate}…': 'Forcer le passage de {gate}…',
  'lands in {phase}, guarded by {gate}': 'atterrit en {phase}, gardé par {gate}',
  '{n} outstanding there': '{n} ouvertes là',
  'the gate engine did not answer': 'le moteur du gate n’a pas répondu',
  'tally unknown': 'décompte inconnu',
  'Final phase — no gate ahead.': 'Phase finale — aucun gate à venir.',
  'Re-evaluate the gate': 'Réévaluer le gate',
  'Step back…': 'Revenir en arrière…',

  // ── approach vector ──
  'Approach vector': 'Barre de trajectoire',
  '{n} condition skipped at a forced crossing, still unmet': '{n} condition ignorée lors d’une transition forcée, toujours non satisfaite',
  '{n} conditions skipped at a forced crossing, still unmet': '{n} conditions ignorées lors d’une transition forcée, toujours non satisfaites',
  'click to inspect': 'cliquer pour examiner',
  'Step {step} of {count}': 'Étape {step} sur {count}',
  '{n} forced crossing on the record': '{n} transition forcée dans le protocole',
  '{n} forced crossings on the record': '{n} transitions forcées dans le protocole',
  '{n} transition': '{n} transition',
  '{n} transitions': '{n} transitions',
  'since {date}': 'depuis {date}',
  'recorded': 'consigné',

  // ── the gate ──
  '— not evaluated': '— non évalué',
  '{n} not yet applicable': '{n} pas encore applicables',
  '{n} condition, no values': '{n} condition, aucune valeur',
  '{n} conditions, no values': '{n} conditions, aucune valeur',
  'The labels are code-level constants and are shown because they are real. Their values come from {source}, which answered: “{message}”. Nothing was written. Forcing still works — it records a reason, not a gate reading.': 'Les libellés sont des constantes du code et sont affichés parce qu’ils sont réels. Leurs valeurs proviennent de {source}, qui a répondu : «{message}». Rien n’a été écrit. Forcer reste possible — cela consigne une justification, pas une évaluation du gate.',
  'value unknown': 'valeur inconnue',
  'manual': 'manuel',
  'Retry': 'Réessayer',
  'Outstanding': 'Ouvertes',
  'what stands between {code} and {phase}': 'ce qui se trouve entre {code} et {phase}',
  'closure': 'la clôture',
  'nothing': 'rien',
  'Nothing outstanding.': 'Rien n’est ouvert.',
  'Every condition on {gate} is held. The advance control above is live.': 'Chaque condition sur {gate} est satisfaite. Le contrôle d’avancement ci-dessus est actif.',
  'Held‖conditions': 'Satisfaites',
  'collapse': 'réduire',
  'show the {n} condition already held': 'afficher la {n} condition déjà satisfaite',
  'show the {n} conditions already held': 'afficher les {n} conditions déjà satisfaites',
  'nothing on this gate is held yet': 'rien n’est encore satisfait sur ce gate',
  'Add a condition to {gate}…': 'Ajouter une condition à {gate}…',
  'Add': 'Ajouter',
  'standard conditions cannot be removed — untick them': 'les conditions standard ne peuvent pas être retirées — décochez-les',

  // ── ahead / behind ──
  'What is ahead': 'Ce qui reste à venir',
  'read-only · nothing here can be ticked yet': 'lecture seule · rien ne peut encore être coché ici',
  '{n} conditions ahead read as satisfied only because nothing has been recorded against them yet (no defect, no change request, no acceptance record). They are shown as {dash}, not as held, so a far gate cannot look nearer than a near one.': '{n} conditions à venir ne semblent satisfaites que parce que rien n’a encore été consigné contre elles (aucun défaut, aucune demande de modification, aucun procès-verbal d’acceptation). Elles s’affichent comme {dash}, non comme satisfaites, afin qu’un gate lointain ne paraisse pas plus proche qu’un gate proche.',
  'What is behind': 'Ce qui est derrière',
  'show the {n} gate already crossed': 'afficher le {n} gate déjà franchi',
  'show the {n} gates already crossed': 'afficher les {n} gates déjà franchis',
  '{n} skipped at a forced crossing, still unmet': '{n} ignorées lors d’une transition forcée, toujours non satisfaites',
  'nothing left owing': 'plus rien n’est en souffrance',

  // ── the record ──
  'The record': 'Le protocole',
  '{n} transition · append-only': '{n} transition · ajout seul',
  '{n} transitions · append-only': '{n} transitions · ajout seul',
  'forced': 'forcé',
  'back': 'retour',
  '{gate} stood at {tally}': '{gate} en était à {tally}',
  '{met} of {total}': '{met} sur {total}',
  'clear at the time': 'libre à l’époque',
  '{n} unmet at the time': '{n} non satisfaites à l’époque',
  '{still} of the {total} condition skipped on {gate} at this crossing is still unmet: {list}.': '{still} sur {total} condition ignorée sur {gate} lors de cette transition est toujours non satisfaite : {list}.',
  '{still} of the {total} conditions skipped on {gate} at this crossing is still unmet: {list}.': '{still} sur {total} conditions ignorées sur {gate} lors de cette transition est toujours non satisfaite : {list}.',
  '{still} of the {total} conditions skipped on {gate} at this crossing are still unmet: {list}.': '{still} sur {total} conditions ignorées sur {gate} lors de cette transition sont toujours non satisfaites : {list}.',
  'system': 'Système',
  'No transition has been recorded': 'Aucune transition n’a été consignée',
  'The engagement has not left its opening phase. A row lands in {table} the moment it does.': 'Le mandat n’a pas quitté sa phase initiale. Dès qu’il le fait, une ligne apparaît dans {table}.',
  'Document classification, uploads, portal previews and proposal decisions are {not} here — they are the audit log, and they live on {link}. This section carries only what moved the engagement. Every figure above comes from {source}.': 'Le classement des documents, les téléversements, les aperçus du portail et les décisions sur les propositions ne sont {not} ici — ils relèvent de la piste d’audit et se trouvent sous {link}. Cette section ne porte que ce qui a fait avancer le mandat. Chaque chiffre ci-dessus provient de {source}.',
  'not': 'pas',
  'Admin · audit': 'Admin · piste d’audit',

  // ── step back ──
  'Step back': 'Revenir en arrière',
  'Backward moves are always permitted and always recorded — a backward move crosses no gate. Pick where {code} goes.': 'Les mouvements vers l’arrière sont toujours autorisés et toujours consignés — un mouvement vers l’arrière ne franchit aucun gate. Choisissez où {code} se rend.',
  'Move back to {phase} →': 'Revenir à {phase} →',
  'guarded by {gate} on the way out again': 'à nouveau gardé par {gate} en sortie',
  'Cancel': 'Annuler',

  // ── force override ──
  'Force past {gate}': 'Forcer le passage de {gate}',
  'Override on the permanent record': 'Dérogation dans le protocole permanent',
  'Moving {code} from {from} to {to} with {n} condition unmet. The reason below is written to the phase transition, snapshot-stamped with the gate state, and read back in the record forever.': '{code} passe de {from} à {to} avec {n} condition non satisfaite. La justification ci-dessous est inscrite dans la transition de phase, horodatée avec l’état du gate, et restituée pour toujours dans le protocole.',
  'Moving {code} from {from} to {to} with {n} conditions unmet. The reason below is written to the phase transition, snapshot-stamped with the gate state, and read back in the record forever.': '{code} passe de {from} à {to} avec {n} conditions non satisfaites. La justification ci-dessous est inscrite dans la transition de phase, horodatée avec l’état du gate, et restituée pour toujours dans le protocole.',
  'What the snapshot will say is unmet': 'Ce que l’instantané indiquera comme non satisfait',
  'manual · not ticked': 'manuel · non coché',
  'These become the engagement’s debt: the record will show them as skipped, and this page will keep saying so until they are met.': 'Elles deviennent la dette du mandat : le protocole les affichera comme ignorées, et cette page continuera de le dire jusqu’à ce qu’elles soient satisfaites.',
  'Override reason': 'Justification de la dérogation',
  '— your words, quoted back verbatim': '— vos mots, cités mot pour mot',
  'Why is this move justified despite the gate?': 'Pourquoi ce mouvement est-il justifié malgré le gate ?',
  'I accept that this override is permanent and visible in the engagement record.': 'J’accepte que cette dérogation soit permanente et visible dans le protocole du mandat.',
  'Force to {phase}': 'Forcer vers {phase}',

  // ── the engagement record ──
  'Engagement record — {code}': 'Dossier du mandat — {code}',
  'Name': 'Nom',
  'Commercial model': 'Modèle commercial',
  'Currency': 'Devise',
  'Inherited from the client; everything produced inside this engagement is written in it.': 'Hérité du client ; tout ce qui est produit dans ce mandat y est rédigé.',
  'Language': 'Langue',
  'Review window (d)': 'Délai de vérification (j)',
  'Sponsor': 'Sponsor',
  'not named yet': 'pas encore nommé',
  'no contacts on this client': 'aucun contact chez ce client',
  'Signs the SOW and acceptance records; clears the counterpart condition on {gate}.': 'Signe la SOW et les procès-verbaux d’acceptation ; satisfait la condition correspondante sur {gate}.',
  'Estimate ({currency})': 'Estimation ({currency})',
  'Satisfies {gate} until milestones are priced.': 'Satisfait {gate} jusqu’à ce que les jalons soient chiffrés.',
  'Kickoff date': 'Date de kickoff',
  'Parent engagement': 'Mandat parent',
  'The code {code} is immutable — it is baked into refs and the agent workspace. Gate {gate} reads the kickoff date; the review window drives deemed-acceptance timers on every acceptance record issued from now on.': 'Le code {code} est immuable — il est intégré aux refs et à l’espace de travail de l’agent. Le gate {gate} lit la date de kickoff ; le délai de vérification règle les échéances de l’acceptation tacite sur chaque procès-verbal d’acceptation émis désormais.',
  'Restore': 'Rétablir',
  'Archive': 'Archiver',
  'Saving…': 'Enregistrement…',
  'Save': 'Enregistrer',

  // ── confirm dialogs ──
  'Archive engagement': 'Archiver le mandat',
  'Archive {code}? Nothing is deleted — the engagement drops out of the active list and its portal, register and history stay exactly as they are. You can restore it from this dialog.': 'Archiver {code} ? Rien n’est supprimé — le mandat sort de la liste active, et son portail, son registre et son historique restent exactement tels quels. Vous pouvez le rétablir depuis cette boîte de dialogue.',
  // ── clone / variante de périmètre ──
  'Duplicate…': 'Dupliquer…',
  'Duplicate': 'Dupliquer',
  'Duplicating…': 'Duplication…',
  'Copy the register into a new engagement to work a scope variant': 'Copier le registre dans un nouveau mandat pour travailler une variante de périmètre',
  'Duplicate engagement': 'Dupliquer le mandat',
  'Scope variant created': 'Variante de périmètre créée',
  'Copies the register of {code} — requirements, their current wording, evidence and acceptance criteria (same refs, clean history) — into a new engagement. SOWs, baselines, tests and delivery logs are NOT copied; the new engagement starts in discovery.': 'Copie le registre de {code} — exigences, leur formulation actuelle, preuves et critères d’acceptation (mêmes références, historique vierge) — dans un nouveau mandat. Les SOW, lignes de base, tests et journaux de livraison ne sont PAS copiés ; le nouveau mandat démarre en phase discovery.',
  'New engagement name': 'Nom du nouveau mandat',
  'New code (optional)': 'Nouveau code (facultatif)',
  'derived from {code} if left blank': 'dérivé de {code} si laissé vide',
  // ── import de livrables ──
  'Import deliverables…': 'Importer des livrables…',
  'Import deliverables': 'Importer des livrables',
  'Importing…': 'Importation…',
  'Import': 'Importer',
  'Copy deliverables (with their requirement links) from a sibling engagement': 'Copier des livrables (avec leurs liens aux exigences) depuis un mandat apparenté',
  'Copies the chosen deliverables — with their requirement links, content items and dependencies — into {code}. Links resolve by requirement ref; a deliverable whose requirement is not in this engagement copies without that link. Refs already present here are skipped, so this is safe to repeat.': 'Copie les livrables choisis — avec leurs liens aux exigences, leurs éléments de contenu et leurs dépendances — dans {code}. Les liens se résolvent par référence d’exigence ; un livrable dont l’exigence est absente de ce mandat est copié sans ce lien. Les références déjà présentes sont ignorées : l’import peut être répété sans risque.',
  'Source engagement': 'Mandat source',
  'Choose a source engagement': 'Choisir un mandat source',
  '{n} of {total} selected': '{n} sur {total} sélectionnés',
  'Select all': 'Tout sélectionner',
  'Select none': 'Ne rien sélectionner',
  'No deliverables to import from that engagement': 'Aucun livrable à importer depuis ce mandat',
  'Deliverables imported': 'Livrables importés',
  'copied': 'copiés',
  'already present, skipped': 'déjà présents, ignorés',
  'links': 'liens',
  'unresolved': 'non résolus',
  'Remove gate condition': 'Retirer la condition du gate',
  'Remove': 'Retirer',
  'Remove the custom condition “{label}” from gate {gate}? Standard conditions cannot be removed — untick them instead.': 'Retirer la condition personnalisée «{label}» du gate {gate} ? Les conditions standard ne peuvent pas être retirées — décochez-les à la place.',
}, 'EngagementPage');
